module.exports = __webpack_public_path__ + "img/theatre_1.3dce8481.jpg";